// TODO: Get rid of linkToolbarClassName

import { Editor } from 'slate';
import removeLink from '@atlas/tool/box/slate/removeLink';
import addLink from '@atlas/tool/box/slate/addLink';
import areSamePoints from '@atlas/tool/box/slate/areSamePoints';
import sortSelection from '@atlas/tool/box/slate/sortSelection';
import isUrl from '@atlas/tool/box/type/isUrl';
import changeEditorSelection from '@atlas/tool/box/slate/changeEditorSelection';

export default function toggleLink(editor: Editor): void {
    if (!editor.selection) return;

    if (removeLink(editor)) return;

    const { anchor, focus } = editor.selection;
    const isCollapsed = areSamePoints(anchor, focus);

    if (isCollapsed) {
        addLink(editor);
    } else {
        const text = Editor.string(editor, editor.selection);
        if (isUrl(text)) addLink(editor, text);
        else addLink(editor);
    }

    // It probably could be done better, but it will require a lot of refactoring
    let focusTries = 50;
    const focusInput = () => {
        const container = document.querySelector<HTMLInputElement>(`.${linkToolbarClassName}`);
        if (--focusTries && !parseFloat(container?.style.opacity || '0')) setTimeout(focusInput, 40);
        else requestAnimationFrame(() => container?.querySelector<HTMLInputElement>('input')?.focus());
    };
    focusInput();

    if (!isCollapsed) {
        const selectionEnd = sortSelection(editor.selection)[1];

        changeEditorSelection(editor, {
            anchor: selectionEnd,
            focus: selectionEnd,
        });
    }
}

// #region Helpers

export const linkToolbarClassName = 'rich-editor-toolbar__link';

// #endregion

// #region Tests

if (import.meta.vitest) {
    const { describe, it } = import.meta.vitest;
    describe('removeLink', async () => {
        it.todo('🤷🏼');
    });
}

// #endregion
